import React from 'react'

import { Dialog } from 'primereact/dialog'
import DialogFooter from '../../dialogFooter'
import CentralService from '../../../app/service/central/centralService'
import { DataTable } from 'primereact/datatable'
import ConstantsUtil from '../../../context/constantsUtil'
import GeneralServices from '../../../app/service/generalServices'
import { Column } from 'primereact/column'
import { OverlayPanel } from 'primereact/overlaypanel'
import { Tooltip } from 'primereact/tooltip'
import { Checkbox } from 'primereact/checkbox'
import { Tag } from 'primereact/tag'
import classNames from 'classnames'
import FluxoCaixaPrevistoService from '../../../app/service/relatorios/fluxoCaixaPrevistoService'
import HandleErrorService from '../../../app/service/handleErrorService'
import { Button } from 'primereact/button'
import * as popUp from '../../toastr'
import TableFilters from '../../tableFilters'
import TooltipButton from '../../tooltipButton'
import EditProvisaoDialog from '../../contasAPagar/provisoes/editProvisaoDialog'
import VisualizarDanfeButton from '../../nf/visualizarDanfeButton'
import DadosPagamentoSalvoParcelaProvisaoDialog from '../../contasAPagar/provisoes/dadosPagamentoSalvoParcelaProvisaoDialog'
import InformarDadosPagamentoDialog from '../../contasAPagar/provisoes/InformarDadosPagamentoDialog'
import ConfirmationDialog from '../../confirmationDialog'
import ProvisaoService from '../../../app/service/contasAPagar/provisaoService'
import DDABoletoPagamentoService from '../../../app/service/relatorios/ddaBoletoPagamentoService'

// sufixo dos nomes de state dos filtros da tabela de unificação (ex: selectedStatusUnificacao), pra não misturar com os da tabela principal
const SUFIXO_STATE_FILTROS_UNIFICACAO = 'Unificacao'

class DetalhamentoFluxoCaixaPrevistoDialog extends React.Component {

    constructor(){
        super()
        this.centralService = new CentralService();
        this.fluxoCaixaPrevistoService = new FluxoCaixaPrevistoService();
        this.tableFilters = new TableFilters();
        this.provisaoService = new ProvisaoService()
        this.ddaBoletoPagamentoService = new DDABoletoPagamentoService()
        this.dt = React.createRef()
        // ref separado pra tabela do dialog de unificação, senão o filtro dela filtra a tabela principal
        this.dtUnificacao = React.createRef()
        this.boletoSugeridoOverlayPanel = React.createRef()
        this.statusConciliacaoTooltipRef = React.createRef()
    }

    state = {
        
        didUpdated: false,
        loading: false,
        
        detalhamentoList: {},

        displayDetalhamentoUnificacaoDialog: false,
        detalhamentoUnificacaoSaidaList: [],
        lancamentoUnificadoSaidaDetalhamento: {},

        selectedLancamentos: [],

        // guarda a lista que a tabela está de fato exibindo (após filtro/ordenação), pra "selecionar todas" não marcar linhas escondidas pelo filtro
        filteredList: null,
        filteredUnificacaoList: null,

        valorTotal: 0.0,

        displayEditProvisaoDialog: false,
        idProvsisaoToEdit: null,
        idProvisaoRecebimentoToEdit: null,

        parcelaToViewDadosPagamento: {},
        displayDadosPagamentoDialog: false,

        parcelasInformarPagamentoIdList: [],
        displayInformarPagamentoDialog: false,

        displayConfirmDesfazerPagamentoDialog: '',
        parcelasProvisaoToDesfazerPagamentoIdList: '',

        boletoSugeridoSelecionado: {},
        lancamentoDoBoletoSugerido: {},

    }

    componentDidUpdate(){
        if( this.props.element && this.props.element.tipo !== ConstantsUtil.saldoLabel && this.props.visible && !this.state.didUpdated ){
            this.searchDetalhamentoFluxoCaixaPrevisto()
            this.setState({didUpdated: true})
        }

        // as linhas da tabela são recriadas a cada fetch/filtro/página, então o Tooltip precisa reconsultar o DOM pra achar os ícones novos
        if(this.statusConciliacaoTooltipRef.current){
            this.statusConciliacaoTooltipRef.current.updateTargetEvents()
        }
    }

    searchDetalhamentoFluxoCaixaPrevisto = () => {
        // console.log("element: ", this.props.element)

        this.resetTable()

        this.setState({
            loading: true,
            selectedLancamentos: [],
            detalhamentoList: '',
            filteredList: null,
        })
        // console.log("element: ", element)
        this.fluxoCaixaPrevistoService.getDetalhamento(this.props.element)
        .then(response => {
            let detalhamentoList = response.data
            this.trataDados(detalhamentoList)
            this.setState({detalhamentoList})
            this.calculaValorTotal(response.data)
        })
        .catch(error => {
            HandleErrorService.handleError(error)
        })
        .finally(() => {
            this.setState({loading: false})
        })
    }

    trataDados = (detalhamentoList) => {
        detalhamentoList.forEach(detalhamento => {
            detalhamento.recorrencia = detalhamento.uuidRecorrenciaProvisao ? true : false
            detalhamento.recorrenciaString = detalhamento.uuidRecorrenciaProvisao ? 'Sim' : 'Não'
            detalhamento.statusConciliacaoBancariaString = detalhamento.statusConciliacaoBancaria ? 'Conciliado' : 'Não Conciliado'
        })
    }

    calculaValorTotal = list => {
        // console.log("calculaValorTotal: ", list)
        let valorTotal = 0.0
        list.forEach(item => valorTotal += item.valor)
        this.setState({valorTotal: GeneralServices.valueBodyTemplate(valorTotal)})
    }


    hideDialog = () => {
        this.props.hideDialog()
        this.setState({
            didUpdated: false,
            selectedLancamentos: [],
            filteredList: null,
        })
    }

    hideDetalhamentoUnificacaoSaidaDialog = () => {
        this.setState({
            displayDetalhamentoUnificacaoDialog: false,
            detalhamentoUnificacaoSaidaList: [],
            lancamentoUnificadoSaidaDetalhamento: {},
            selectedLancamentos: [],
            filteredUnificacaoList: null,
        })
        this.limpaFiltrosTabelaUnificacao()
    }

    // zera o que estava selecionado nos filtros da tabela de unificação, pra não abrir a próxima já "filtrada" só no MultiSelect
    limpaFiltrosTabelaUnificacao = () => {
        const nomesStateFiltros = [
            'selectedDataEmissao',
            'selectedDataLancamento',
            'selectedDataValidacao',
            'selectedDataCompetencia',
            'selectedNome',
            'selectedValor',
            'selectedFormaDePagamento',
            'selectedOrigem',
            'selectedRecorrencia',
            'selectedStatus',
            'selectedStatusConciliacaoBancaria',
        ]
        let novoState = {}
        for(let nomeState of nomesStateFiltros){
            novoState[nomeState + SUFIXO_STATE_FILTROS_UNIFICACAO] = []
        }
        this.setState(novoState)
    }

    getList = () => {
        if(this.props.element){
            if(this.props.element.tipo === ConstantsUtil.saldoLabel){
                return this.props.fluxoCaixaPrevisto && this.props.fluxoCaixaPrevisto.saldoInicial ? this.props.fluxoCaixaPrevisto.saldoInicial.saldoContaBancariaList : []
            }
            else{
                //LANCAMENTO
                return this.state.detalhamentoList
            }

        }
    }

    
    rowClass(rowData) {
        return {
            [ConstantsUtil.totaisTableLabel]: rowData.totalItem
        }
    }

    getCompleteHeader = () => {
        return `${this.props.header} (${this.props.element.dataString})`
    }

    getCompleteHeaderDetalhamentoUnificacao = () => {
        return `${this.state.lancamentoUnificadoSaidaDetalhamento.nome} (${this.props.element.dataString})`
    }

    detalhamentoToExportTemplate = () => {
        var finalList = []
        this.getList().forEach(item => {
            finalList.push({
                ['Data de Lançamento']: item.dataLancamento,
                ['Data de Pagamento']: item.nome !== ConstantsUtil.totaisTableUpperCaseLabel ? this.props.element.dataString : '',
                Nome: item.nome,
                Valor: item.valor
            })
        })
        return finalList
    }

    handleValorClickOnPagamentos = rowData => {
        if(rowData.unificacao){
            this.viewDetalhamentoUnificacao(rowData)
        }
        else if(rowData.origem === ConstantsUtil.origemFluxoCaixaPrevistoProvisaoRecebimento) {
            this.editProvisaoRecebimento(rowData)
        }
        else if(rowData.idProvisao){
            this.editProvisao(rowData)
        }
    }

    editProvisao = rowData => {
        this.setState({
            displayEditProvisaoDialog: true,
            idProvsisaoToEdit: rowData.idProvisao,
            idProvisaoRecebimentoToEdit: null
        })
    }

    editProvisaoRecebimento = rowData => {
        this.setState({
            idProvsisaoToEdit: null,
            displayEditProvisaoDialog: true,
            idProvisaoRecebimentoToEdit: rowData.idProvisao
        })
    }

    viewDetalhamentoUnificacao = rowData => {
        // console.log("rowData: ", rowData)
        this.setState({lancamentoUnificadoSaidaDetalhamento: rowData})
        this.fluxoCaixaPrevistoService.getDetalhamentoUnificacaoSaida(rowData.idUnificacao)
        .then(response => {
            // console.log(response.data)
            // preenche recorrenciaString e statusConciliacaoBancariaString, que as colunas e os filtros usam
            this.trataDados(response.data)
            this.limpaFiltrosTabelaUnificacao()
            this.setState({
                detalhamentoUnificacaoSaidaList: response.data,
                displayDetalhamentoUnificacaoDialog: true,
                filteredUnificacaoList: null,
            })
        })
        .catch(error => 
            HandleErrorService.handleError(error)
        )
    }

    handleSelectionChange = async (e) => {

        // console.log("handleSelectionChange: ", e.value)
        // let selecionouLancamentoSemFornecedor = false
        let selectedList = e.value.filter(item => item.nome !== ConstantsUtil.totaisTableUpperCaseLabel)
        let selecionouLancamentoUnificado = false
        let selectedItems = selectedList

        
        // selectedItems = selectedItems.filter(selectedItem => {

        //     let lancamentoSemFornecedor = !selectedItem.fornecedor || GeneralServices.isEmptyObject(selectedItem.fornecedor)
        //     let lancamentoUnificado = selectedItem.idUnificacao
        //     let podeSelecionar = !lancamentoSemFornecedor && !lancamentoUnificado
        //     if(lancamentoSemFornecedor){
        //         selecionouLancamentoSemFornecedor = selecionouLancamentoSemFornecedor || true
        //     }
        //     if(lancamentoUnificado){
        //         selecionouLancamentoUnificado = selecionouLancamentoUnificado || true
        //     }
        //     return podeSelecionar
        // })

        await this.setState({selectedLancamentos: selectedItems})

        if(this.state.selectedLancamentos && this.state.selectedLancamentos.length > 0){
            this.calculaValorTotal(this.state.selectedLancamentos)
        }
        else{
            this.calculaValorTotal(this.getList())
        }

        if(selecionouLancamentoUnificado){
            popUp.infoPopUp(`Selecione apenas lançamentos ainda não unificados.`)
            return
        }

        // if(selecionouLancamentoSemFornecedor){
        //     popUp.infoPopUp(`Não é possível unificar lançamentos sem fornecedor.`)
        //     return
        // }


        this.checaLancamentosSelecionadosFornecedoresDiferentes()

    }

    isLancamentoSelecionado = (rowData) => {
        for(let lancamentoSelecionado of this.state.selectedLancamentos){
            if(lancamentoSelecionado.idParcelaProvisao === rowData.idParcelaProvisao){
                return true
            }
        }
        return false
    }

    // marca ou desmarca só o lançamento clicado, sem mexer no resto da seleção
    toggleSelecaoLancamento = (rowData) => {
        let novaSelecao = []

        if(this.isLancamentoSelecionado(rowData)){
            for(let lancamentoSelecionado of this.state.selectedLancamentos){
                if(lancamentoSelecionado.idParcelaProvisao !== rowData.idParcelaProvisao){
                    novaSelecao.push(lancamentoSelecionado)
                }
            }
        }
        else{
            for(let lancamentoSelecionado of this.state.selectedLancamentos){
                novaSelecao.push(lancamentoSelecionado)
            }
            novaSelecao.push(rowData)
        }

        this.handleSelectionChange({value: novaSelecao})
    }

    estaTudoSelecionado = (list) => {
        if(!list || !Array.isArray(list) || list.length === 0){
            return false
        }

        for(let item of list){
            if(item.nome !== ConstantsUtil.totaisTableUpperCaseLabel){
                if(!this.isLancamentoSelecionado(item)){
                    return false
                }
            }
        }
        return true
    }

    // se já estiver tudo selecionado, o clique desmarca todos. Senão, seleciona todos os lançamentos da lista (menos a linha de totais)
    toggleSelecaoTodos = (list, jaEstaTudoSelecionado) => {
        let novaSelecao = []

        if(!jaEstaTudoSelecionado){
            for(let item of list){
                if(item.nome !== ConstantsUtil.totaisTableUpperCaseLabel){
                    novaSelecao.push(item)
                }
            }
        }

        this.handleSelectionChange({value: novaSelecao})
    }

    checaLancamentosSelecionadosFornecedoresDiferentes = () => {
        let fornecedoresIdList = []
        this.state.selectedLancamentos.forEach(lancamentoSelecionado => {
            if(lancamentoSelecionado.fornecedor && !GeneralServices.isEmptyObject(lancamentoSelecionado.fornecedor)){
                fornecedoresIdList.push(lancamentoSelecionado.fornecedor.id)
            }
        })
     
        fornecedoresIdList = [...new Set(fornecedoresIdList)];
        // if(fornecedoresIdList.length > 1){
        //     popUp.infoPopUp(`Foram selecionados lançamentos de diferentes fornecedores.`)
        // }
        
    }

    resetTable = () => {
        if(this.dt && this.dt.current){
            this.dt.current.reset()
        }
        this.setState({
            selectedDataLancamento: [],
            selectedNome: [],
            selectedValor: [],
            selectedFormaDePagamento: [],
            selectedOrigemselectedOrigem: [],
        })
    }

    callUnificar = () => {
        
        if(!this.state.selectedLancamentos || this.state.selectedLancamentos.length === 0){
            popUp.infoPopUp("Selecione ao menos 1 lançamento para unificar.")
            return
        }

        this.setState({loading: true})
        this.fluxoCaixaPrevistoService.unificarLancamentos(this.state.selectedLancamentos)
        .then(response => {
            popUp.successPopUp("Lançamentos unificados com sucesso!")
            this.searchDetalhamentoFluxoCaixaPrevisto()
        })
        .catch(error => {
            HandleErrorService.handleError(error)
            this.setState({loading: false})
        })

    }

    callDesunificar = () => {
        if(!this.state.selectedLancamentos || this.state.selectedLancamentos.length === 0){
            popUp.infoPopUp("Selecione ao menos 1 lançamento para separar.")
            return
        }

        this.setState({loading: true})
        this.fluxoCaixaPrevistoService.desunificarLancamentos(this.state.selectedLancamentos)
        .then(response => {
            popUp.successPopUp("Lançamentos separados com sucesso!")
            this.setState({displayDetalhamentoUnificacaoDialog: false})
            this.searchDetalhamentoFluxoCaixaPrevisto()
        })
        .catch(error => 
            HandleErrorService.handleError(error)
        )
        .finally(() => {
            this.setState({loading: false})
        })        
    }

    getListTratada = () => {
        // let list = this.dt.current && this.dt.current.props ? this.dt.current.props.value : []
        let list = this.getList()
        let retorno = list && !GeneralServices.isEmptyObject(list) ? list : []
        // console.log("retorno: ", retorno)
        // return []
        return retorno
    }

    hideEditProvisaoDialog = () => {
        this.setState({
            displayEditProvisaoDialog: false,
            idProvsisaoToEdit: null,
            idProvisaoRecebimentoToEdit: null

        })
    }

    hideEditProvisaoRecebimentoDialog = () => {
        this.setState({
            displayEditProvisaoDialog: false,
            idProvsisaoToEdit: null,
            idProvisaoRecebimentoToEdit: null
        })
    }

    searchAposSalvarProvisao = () => {
        if(this.state.displayDetalhamentoUnificacaoDialog){
            this.setState({displayDetalhamentoUnificacaoDialog: false})
        }
        this.searchDetalhamentoFluxoCaixaPrevisto()
    }

    
    viewDadosPagamento = (parcelaProvisao) => {
        this.setState({
            parcelaToViewDadosPagamento: parcelaProvisao,
            displayDadosPagamentoDialog: true
        })
    }

    hideDadosPagamentoDialog = () => {
        this.setState({
            parcelaToViewDadosPagamento: {},
            displayDadosPagamentoDialog: false
        })
    }

    abrirBoletoSugerido = (event, rowData) => {
        // guarda o boleto e o lançamento da linha clicada, e abre o painel com os dados dele
        this.setState({
            boletoSugeridoSelecionado: rowData.ddaBoletoPagamentoDTO,
            lancamentoDoBoletoSugerido: rowData
        })
        this.boletoSugeridoOverlayPanel.current.toggle(event)
    }

    montaBodyConfirmarBoletoSugerido = (rowData, boleto) => {
        let idParcela = null
        let idUnificacao = null

        // se o lançamento é uma unificação, manda o idUnificacao e não manda idParcela
        if(rowData.idUnificacao){
            idUnificacao = rowData.idUnificacao
        }
        else{
            idParcela = rowData.idParcelaProvisao
        }

        return {
            idBoleto: boleto.id,
            idParcela: idParcela,
            idUnificacao: idUnificacao
        }
    }

    confirmarBoletoSugerido = () => {
        const rowData = this.state.lancamentoDoBoletoSugerido
        const boleto = this.state.boletoSugeridoSelecionado

        const body = this.montaBodyConfirmarBoletoSugerido(rowData, boleto)

        this.setState({loading: true})
        this.ddaBoletoPagamentoService.confirmar(body)
        .then(response => {
            popUp.successPopUp("Boleto confirmado com sucesso!")
            this.boletoSugeridoOverlayPanel.current.hide()
            this.searchDetalhamentoFluxoCaixaPrevisto()
        })
        .catch(error => {
            HandleErrorService.handleError(error)
            this.setState({loading: false})
        })
    }

    desconfirmarBoletoSugerido = () => {
        const boleto = this.state.boletoSugeridoSelecionado

        this.setState({loading: true})
        this.ddaBoletoPagamentoService.desconfirmar({idBoleto: boleto.id})
        .then(response => {
            popUp.successPopUp("Confirmação do boleto desfeita com sucesso!")
            this.boletoSugeridoOverlayPanel.current.hide()
            this.searchDetalhamentoFluxoCaixaPrevisto()
        })
        .catch(error => {
            HandleErrorService.handleError(error)
            this.setState({loading: false})
        })
    }

    informarPagamento = () => {

        // console.log("this.state.selectedLancamentos: ", this.state.selectedLancamentos)

        if(!this.state.selectedLancamentos || this.state.selectedLancamentos.length === 0){
            popUp.infoPopUp("Selecione ao menos 1 lançamento para informar o pagamento.")
            return
        }
        
        for(let selectedLancamento of this.state.selectedLancamentos){
            if(selectedLancamento.unificacao){
                popUp.errorPopUp("Foi selecionado algum lançamento unificado.")
                return;
            }
        }

        this.setState({
            parcelasInformarPagamentoIdList: this.state.selectedLancamentos.map(item => item.idParcelaProvisao),
            displayInformarPagamentoDialog: true
        })

    }

    callDesfazerPagamento = () => {

        if(!this.state.selectedLancamentos || this.state.selectedLancamentos.length === 0){
            popUp.infoPopUp("Selecione ao menos 1 lançamento para desfazer o pagamento.")
            return
        }

        for(let selectedLancamento of this.state.selectedLancamentos){
            if(selectedLancamento.unificacao){
                popUp.errorPopUp("Foi selecionado algum lançamento unificado.")
                return;
            }
        }

        this.setState({
            displayConfirmDesfazerPagamentoDialog: true
        })
    }

    hideConfirmDesfazerPagamentoDialog = () => {
        this.setState({displayConfirmDesfazerPagamentoDialog: false})
    }    

    desfazerPagamento = () => {
        this.setState({loading: true})
        this.hideConfirmDesfazerPagamentoDialog()
        this.provisaoService.desfazerPagamento(
            {
                idParcelaProvisaoList: this.state.selectedLancamentos.map(item => item.idParcelaProvisao)
            }
        )
        .then(response => {
            this.searchAposSalvarProvisao()
        }).catch(error => {
            HandleErrorService.handleError(error)
        })
        .finally(() => {
            this.setState({loading: false})
        })
        
    }    

    hideInformarPagamentoDialog = () => {
        this.setState({
            parcelasInformarPagamentoIdList: [],
            displayInformarPagamentoDialog: false
        })
    }

    onSaveInformarPagamento = () => {
        this.searchAposSalvarProvisao()
    }    


    render(){

        // monta os filtros (MultiSelect) de uma tabela específica.
        // cada tabela precisa do seu próprio ref, da sua própria lista (pras opções) e do seu próprio state de selecionados,
        // senão o filtro da tabela de unificação acaba filtrando a tabela principal que está por trás
        const montaFiltrosDaTabela = (dataTableRef, listaDaTabela, sufixoNomeState) => {

            const renderFiltro = (nomeStateBase, propriedade) => {
                const nomeState = nomeStateBase + sufixoNomeState
                return this.tableFilters.renderTableFilter(
                    dataTableRef,
                    this.state[nomeState],
                    listaDaTabela,
                    nomeState,
                    (name, value) => this.setState({[name]: value}),
                    propriedade,
                    '100%',
                    "Selecione"
                )
            }

            return {
                dataEmissao: renderFiltro('selectedDataEmissao', 'dataEmissao'),
                dataLancamento: renderFiltro('selectedDataLancamento', 'dataLancamento'),
                dataValidacao: renderFiltro('selectedDataValidacao', 'dataValidacao'),
                dataCompetencia: renderFiltro('selectedDataCompetencia', 'dataCompetencia'),
                nome: renderFiltro('selectedNome', 'nome'),
                valor: renderFiltro('selectedValor', 'valor'),
                formaDePagamento: renderFiltro('selectedFormaDePagamento', 'formaDePagamento.descricao'),
                origem: renderFiltro('selectedOrigem', 'origem'),
                recorrencia: renderFiltro('selectedRecorrencia', 'recorrenciaString'),
                status: renderFiltro('selectedStatus', 'statusPagamento'),
                statusConciliacaoBancaria: renderFiltro('selectedStatusConciliacaoBancaria', 'statusConciliacaoBancariaString'),
            }
        }

        // tabela principal do detalhamento
        const filtrosTabelaPrincipal = montaFiltrosDaTabela(this.dt, this.getListTratada(), '')

        // tabela do dialog de detalhamento da unificação
        const filtrosTabelaUnificacao = montaFiltrosDaTabela(this.dtUnificacao, this.state.detalhamentoUnificacaoSaidaList || [], SUFIXO_STATE_FILTROS_UNIFICACAO)
        
        const footer = (
            <DialogFooter hideDialog = {this.hideDialog} disabled/>
        )
        
        const detalhamentoUnificacaoSaidaFooter = (
            <DialogFooter hideDialog = {this.hideDetalhamentoUnificacaoSaidaDialog} disabled/>
        )



        const renderStatus = (rowData, rowIndex) => {

            const classes = classNames({
                'superavitValue': rowData.statusPagamento === ConstantsUtil.parcelaProvisaoPagaLabel && !rowData.unificacao,
                'deficitValue': rowData.statusPagamento === ConstantsUtil.parcelaProvisaoAguardandoPagamentoLabel && !rowData.unificacao,
                'linkValue': rowData.statusPagamento === ConstantsUtil.parcelaProvisaoPagaLabel && !rowData.unificacao
            });

            if(rowData.statusPagamento === ConstantsUtil.parcelaProvisaoPagaLabel && !rowData.unificacao){
                return(
                    <a 
                        className={classes}
                        onClick={() => this.viewDadosPagamento(rowData)}
                    >
                        {GeneralServices.renderBodyColumnInOneLine(rowData.statusPagamento, rowIndex)}
                    </a>
                )
            }
            else{
                return(
                    <div className={classes}>
                        {GeneralServices.renderBodyColumnInOneLine(rowData.statusPagamento, rowIndex)}
                    </div>
                )
            }
        }

        const renderConfirmDesfazerPagamentoDialog = () => {
            return(
                <ConfirmationDialog
                    visible={this.state.displayConfirmDesfazerPagamentoDialog}
                    header={"Desfazer Pagamento"}
                    confimationMessage={ "Deseja Confirmar?"}
                    confirm={this.desfazerPagamento}
                    hide={this.hideConfirmDesfazerPagamentoDialog}
                />
            )
        }        

        const renderInformarPagamentoDialog = () => {
            return (
                <InformarDadosPagamentoDialog
                    visible={this.state.displayInformarPagamentoDialog}
                    parcelasInformarPagamentoIdList={this.state.parcelasInformarPagamentoIdList}
                    hideDialog={this.hideInformarPagamentoDialog}
                    onSave={this.onSaveInformarPagamento}
                />
            )
        }        

        const renderViewLancamentosLink = (rowData) => {
            
            const valor = rowData.valor
            const isTotal = rowData.totalItem
            
            const classes = classNames({
                'superavitValue': valor >= 0 && !isTotal,
                'deficitValue': valor<0 && !isTotal,
                'right-align': true,
            });
    
                if(rowData.unificacao || rowData.idProvisao){
                    return (
                        <div className='right-align' >
                            <a 
                                className={classes}
                                // onClick={() => this.viewDetalhamentoUnificacao(rowData)}
                                onClick={() => this.handleValorClickOnPagamentos(rowData)}
                            >
                            {GeneralServices.showFormattedIfNotNull(valor, true)}
                        </a>
                    </div>
                    )
                }

                return(
                    <div className={classes}>
                        {GeneralServices.showFormattedIfNotNull(valor, true)}
                    </div>
                )
        }

        const renderCheckboxCell = (rowData) => {
            // linha de totais não é selecionável
            if(rowData.nome === ConstantsUtil.totaisTableUpperCaseLabel){
                return <></>
            }

            return (
                <Checkbox
                    checked={this.isLancamentoSelecionado(rowData)}
                    onChange={() => this.toggleSelecaoLancamento(rowData)}
                />
            )
        }

        // usa a lista filtrada (guardada via onValueChange) quando ela existir, senão cai pra lista completa
        const getListaVisivelParaSelecao = (list, filter) => {
            const listaFiltrada = filter ? this.state.filteredList : this.state.filteredUnificacaoList
            return listaFiltrada || list
        }

        const renderCheckboxHeader = (list) => {
            // enquanto os dados ainda não chegaram da API, list pode vir como objeto vazio
            if(!list || !Array.isArray(list)){
                return <></>
            }

            let existeLinhaSelecionavel = false
            for(let item of list){
                if(item.nome !== ConstantsUtil.totaisTableUpperCaseLabel){
                    existeLinhaSelecionavel = true
                }
            }

            if(!existeLinhaSelecionavel){
                return <></>
            }

            const jaEstaTudoSelecionado = this.estaTudoSelecionado(list)

            return (
                <Checkbox
                    checked={jaEstaTudoSelecionado}
                    onChange={() => this.toggleSelecaoTodos(list, jaEstaTudoSelecionado)}
                />
            )
        }

        // a seleção só deve acontecer clicando nessa coluna de checkbox, nunca clicando em qualquer lugar da linha
        const renderMultiSelectColumn = (list, filter) => {
            if(this.props.element.tipoDetalhamento === ConstantsUtil.saidaLabel){
                const listaVisivel = getListaVisivelParaSelecao(list, filter)
                return (
                    <Column
                        header={renderCheckboxHeader(listaVisivel)}
                        body={renderCheckboxCell}
                        headerStyle={{ width: '50px' }}
                        style ={ {width: '50px', textAlign: 'center'} }
                    />
                )
            }
        }

        const actionViewDanfeNFButton = (rowData) => {
            
            // console.log("actionViewDanfeNFButton: ", rowData)
            
            if(rowData.notaFiscal && rowData.notaFiscal.id){
                return (
                    <VisualizarDanfeButton
                        idComponenteDigital={rowData.notaFiscal.chave}
                        possuiArquivo={rowData.notaFiscal.possuiDanfe}
                    />
                )
            }

            else if(rowData.nfse && rowData.nfse.id){
                return (
                    <VisualizarDanfeButton
                        idComponenteDigital={rowData.nfse.codigoVerificacao}
                        possuiArquivo={rowData.nfse.possuiPdf}
                    />
                )
            }

            else if(rowData.componenteDigitalComprovanteProvisaoManual && rowData.componenteDigitalComprovanteProvisaoManual.id){
                return (
                    <VisualizarDanfeButton
                        idComponenteDigital={rowData.componenteDigitalComprovanteProvisaoManual.id}
                        possuiArquivo={true}
                        tipo={ConstantsUtil.tipoComponenteDigitalComprovanteProvisaoManual}
                    />
                )                
            }


        }

        const renderLinhaBoletoSugerido = (rotulo, valor) => {
            return (
                <div style={{ display: 'flex', justifyContent: 'space-between', gap: '10px', marginBottom: '6px' }}>
                    <span style={{ fontSize: '0.75rem', color: '#888' }}>{rotulo}</span>
                    <span style={{ fontSize: '0.8rem', fontWeight: 500, color: '#333', textAlign: 'right' }}>{valor}</span>
                </div>
            )
        }

        const renderBotaoConfirmarOuDesconfirmar = (boletoJaConfirmado) => {
            if(boletoJaConfirmado){
                return (
                    <Button
                        label="Desconfirmar"
                        icon="pi pi-times"
                        className="p-button-danger small-font small-button"
                        onClick={this.desconfirmarBoletoSugerido}
                        disabled={this.state.loading}
                    />
                )
            }

            return (
                <Button
                    label="Confirmar"
                    icon="pi pi-check"
                    className="p-button-success small-font small-button"
                    onClick={this.confirmarBoletoSugerido}
                    disabled={this.state.loading}
                />
            )
        }

        const renderBoletoSugeridoOverlayPanel = () => {
            const boleto = this.state.boletoSugeridoSelecionado
            const boletoJaConfirmado = boleto.fixo

            return (
                <OverlayPanel ref={this.boletoSugeridoOverlayPanel} showCloseIcon dismissable style={{ width: '320px' }}>

                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                        <div style={{ fontWeight: 'bold', color: '#2c4670' }}>
                            <span className="pi pi-file" style={{ marginRight: '6px' }} />
                            Boleto {boletoJaConfirmado ? 'Confirmado' : 'Sugerido'}
                        </div>

                        <Tag
                            value={boletoJaConfirmado ? 'Confirmado' : 'Sugestão'}
                            severity={boletoJaConfirmado ? 'success' : 'warning'}
                            icon={boletoJaConfirmado ? 'pi pi-check' : 'pi pi-exclamation-triangle'}
                        />
                    </div>

                    <div style={{ borderBottom: '1px solid #e0e0e0', marginBottom: '10px' }} />

                    {renderLinhaBoletoSugerido('Beneficiário', boleto.nomeBeneficiario)}
                    {renderLinhaBoletoSugerido('CNPJ', GeneralServices.formataCpfCnpj(boleto.cnpjBeneficiario))}
                    {renderLinhaBoletoSugerido('Nº Documento', boleto.numeroDocumento)}
                    {renderLinhaBoletoSugerido('Valor', GeneralServices.valueBodyTemplateWithCifrao(boleto.valor))}
                    {renderLinhaBoletoSugerido('Vencimento', boleto.dataVencimento)}
                    {renderLinhaBoletoSugerido('Disponibilizado no DDA em', boleto.dataDisponibilizacaoDDA)}
                    {renderLinhaBoletoSugerido('Importado em', boleto.dataHoraImportacao)}
                    {renderLinhaBoletoSugerido('Origem', boleto.origem)}

                    <div style={{ marginTop: '10px', paddingTop: '10px', borderTop: '1px solid #e0e0e0' }}>
                        <div style={{ fontSize: '0.7rem', color: '#888', marginBottom: '4px' }}>Linha Digitável</div>
                        <div style={{ fontFamily: 'monospace', fontSize: '0.75rem', wordBreak: 'break-all' }}>{boleto.linhaDigitavel}</div>
                    </div>

                    <div style={{ marginTop: '12px', paddingTop: '10px', borderTop: '1px solid #e0e0e0', display: 'flex', justifyContent: 'flex-end' }}>
                        {renderBotaoConfirmarOuDesconfirmar(boletoJaConfirmado)}
                    </div>

                </OverlayPanel>
            )
        }

        const renderBoletoSugerido = (rowData) => {
            // só mostra o botão quando o sistema conseguiu associar um boleto do DDA a esse pagamento
            if(!rowData.ddaBoletoPagamentoDTO){
                return <></>
            }

            const boletoJaConfirmado = rowData.ddaBoletoPagamentoDTO.fixo

            return (
                <TooltipButton
                    tooltip={boletoJaConfirmado ? "Boleto confirmado" : "Ver boleto sugerido pelo sistema"}
                    icon={boletoJaConfirmado ? "pi pi-check-circle" : "pi pi-file"}
                    className={`p-button-rounded p-button-${boletoJaConfirmado ? "success" : "secondary"} p-mr-2`}
                    style={ {maxHeight: '30px', maxWidth: '30px'} }
                    onClick={event => this.abrirBoletoSugerido(event, rowData)}
                />
            )
        }

        const renderBoletoSugeridoColumn = (isDetalhamentoInternoUnificacao) => {
            if(this.props.element.tipoDetalhamento === ConstantsUtil.saidaLabel && !isDetalhamentoInternoUnificacao){
                return (
                    <Column
                        header="Boleto Sugerido"
                        body={renderBoletoSugerido}
                        style ={ {width: '80px', textAlign: 'center'} }
                    />
                )
            }
        }

        const renderDadosPagamentoDialog = () => {
            return (
                <DadosPagamentoSalvoParcelaProvisaoDialog
                    visible={this.state.displayDadosPagamentoDialog}
                    hideDialog={this.hideDadosPagamentoDialog}
                    idParcelaToViewDadosPagamento={this.state.parcelaToViewDadosPagamento.idParcelaProvisao}
                />
            )
        }        
        
        const renderStatusPagamentoColumn = (filtros) => {
            if(this.props.element.tipoDetalhamento === ConstantsUtil.saidaLabel){
                return (
                    <Column
                        header="Status"
                        field="statusPagamento"
                        sortable
                        // body = { (rowData, rowIndex) => GeneralServices.renderBodyColumnInOneLine(rowData.status, rowIndex)}
                        body = { (rowData, rowIndex) => renderStatus(rowData, rowIndex)}
                        // sortable
                        style ={ {width: '100px'} }
                        filter filterElement={filtros.status}
                    />
                )
            }
        }        

        const renderDataEmissao = (filter, filtros) => {
            if(this.props.element.tipoDetalhamento === ConstantsUtil.saidaLabel){
                return (
                    <Column
                        header="Data de Emissão"
                        field="dataEmissao"
                        sortable
                        style ={ {width: '80px'} }
                        filter={filter} filterElement={filtros.dataEmissao}
                    />
                )
            }
        }

        const renderStatusConciliacaoBancaria = (rowData) => {

            if(rowData.nome === ConstantsUtil.totaisTableUpperCaseLabel){
                return(<></>)
            }

            const conciliado = rowData.statusConciliacaoBancaria

            return (
                <i
                    className={`pi ${conciliado ? 'pi-check-circle' : 'pi-times-circle'} status-conciliacao-bancaria-icon`}
                    data-pr-tooltip={conciliado ? 'Conciliado' : 'Não conciliado'}
                    style={{ color: conciliado ? '#1cc71c' : '#FF5252', fontSize: '1.1rem' }}
                />
            )
        }

        const renderDatasValidacaoCompetencia = (filter, filtros) => {
            if(this.props.element.tipoDetalhamento === ConstantsUtil.saidaLabel){
                return (
                    [
,
                        <Column
                            header="Data de Validação"
                            field="dataValidacao"
                            sortable
                            style ={ {width: '80px'} }
                            filter={filter} filterElement={filtros.dataValidacao}
                        />,
                        <Column
                            header="Data de Competência"
                            field="dataCompetencia"
                            sortable
                            style ={ {width: '80px'} }
                            filter={filter} filterElement={filtros.dataCompetencia}
                        />
                    ]
                )
            }
        }

        const renderColunaStatusConciliacaoBancaria = (filter, filtros) => {
            return(
                <Column
                    header="Status Conciliação Bancária"
                    field="statusConciliacaoBancariaString"
                    body={renderStatusConciliacaoBancaria}
                    sortable
                    style ={ {width: '60px', textAlign: 'center'} }
                    // filter={filter}
                    filter
                    filterElement={filtros.statusConciliacaoBancaria}
                />                
            )
        }

        const renderTable = (list, filter, isDetalhamentoInternoUnificacao) => {

            // cada tabela usa os seus próprios filtros (ref + opções + selecionados)
            const filtros = isDetalhamentoInternoUnificacao ? filtrosTabelaUnificacao : filtrosTabelaPrincipal

            // guarda a lista que a tabela está exibindo de fato (após filtro/ordenação/paginação) pra usar no "selecionar todas"
            const handleValueChange = (listaExibida) => {
                if(filter){
                    this.setState({filteredList: listaExibida})
                }
                else{
                    this.setState({filteredUnificacaoList: listaExibida})
                }
                this.calculaValorTotal(listaExibida)
            }

            return(
                <DataTable
                    ref={filter ? this.dt : this.dtUnificacao}
                    value={list}
                    className="p-datatable-sm small-font"
                    dataKey="idParcelaProvisao"
                    selection={this.state.selectedLancamentos}
                    onSelectionChange={this.handleSelectionChange}                  
                    rowClassName={this.rowClass}
                    onValueChange={handleValueChange}
                    rowHover
                    showGridlines
                    scrollable
                    scrollHeight="350px"
                    emptyMessage={ConstantsUtil.nenhumLancamentoEncontradoMessage}
                    loading={this.props.loading || this.state.loading}
                    paginator rows={ConstantsUtil.initialTableQuantityOption}
                    paginatorTemplate={GeneralServices.tablePaginatorTemplate(ConstantsUtil.initialTableQuantityOption, list ? list.length : '')}
                    currentPageReportTemplate="Mostrando de {first} ao {last} de {totalRecords} lançamentos"
                >

                    {renderMultiSelectColumn(list, filter)}

                    {renderDataEmissao(filter, filtros)}

                    <Column
                        header="Data de Lançamento"
                        field="dataLancamento"
                        sortable
                        style ={ {width: '80px'} }
                        filter={filter} filterElement={filtros.dataLancamento}
                    />

                    {renderDatasValidacaoCompetencia(filter, filtros)}

                    <Column
                        header="Nome"
                        field="nome"
                        body={rowData => {
                            return (
                                <div>
                                    {rowData.nome}
                                    {actionViewDanfeNFButton(rowData)}
                                </div>
                            )
                        }}
                        sortable
                        style ={ {width: '300px'} }
                        filter={filter} filterElement={filtros.nome}
                    />

                    <Column
                        header="Valor"
                        field="valor"
                        body={renderViewLancamentosLink}
                        sortable
                        style ={ {width: '80px'} }
                        filter={filter} filterElement={filtros.valor}
                    />

                    {renderBoletoSugeridoColumn(isDetalhamentoInternoUnificacao)}

                    {renderStatusPagamentoColumn(filtros)}

                    {/* <Column
                        header="Forma de Pagamento"
                        field="formaDePagamento.descricao"
                        sortable
                        style ={ {width: '100px'} }
                        filter={filter} filterElement={filtros.formaDePagamento}
                    /> */}

                    {renderColunaStatusConciliacaoBancaria(filter, filtros)}

                    <Column
                        header="Origem"
                        field="origem"
                        sortable
                        style ={ {width: '80px'} }
                        filter={filter} filterElement={filtros.origem}
                    />

                    <Column
                        header="Recorrência"
                        field="recorrenciaString"
                        sortable style ={ {width: '80px'} }
                        body={rowData => GeneralServices.renderStyledColorTableColumn(rowData.recorrenciaString , rowData.recorrencia)}
                        filter filterElement={filtros.recorrencia}
                    />

                </DataTable>
            )
        }

        const renderDetalhamentoUnificacaoSaidaDialog = () => {
            return (
                <Dialog
                    visible={this.state.displayDetalhamentoUnificacaoDialog}
                    style={{ width: '95vw',}}
                    header={this.getCompleteHeaderDetalhamentoUnificacao()}
                    modal
                    className="p-fluid"
                    footer={detalhamentoUnificacaoSaidaFooter}
                    onHide={this.hideDetalhamentoUnificacaoSaidaDialog}
                >

                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

                        <Button
                            label="Separar"
                            className="p-button-danger small-font small-button"
                            icon="pi pi-link"
                            onClick={this.callDesunificar}
                            style={{ maxWidth: '10rem' }}
                        />

                        {renderBotaoInformarPagamento()}
                        {renderBotaoDesfazerPagamento()}                    

                    </div>
                    
                    {renderTable(this.state.detalhamentoUnificacaoSaidaList, false, true)}
                        

                </Dialog>
            )
        }

        const renderBotaoUnificar = () => {
            if(this.props.element.tipoDetalhamento === ConstantsUtil.saidaLabel){
                return (
                    <>
                        {/* Botão à esquerda */}
                        <Button
                            label="Unificar"
                            className="p-button-primary small-font small-button"
                            icon="pi pi-link"
                            onClick={this.callUnificar}
                            style={{ maxWidth: '10rem' }}
                        />
                    </>
                )
            }
            else{
                return (
                    <div />
                )
            }
        }

        const renderBotaoInformarPagamento = () => {
            if(this.props.element.tipoDetalhamento === ConstantsUtil.saidaLabel){
                return (
                    <>
                        <Button
                            label="Informar Pagamento"
                            className="p-button-help small-font small-button right-button"
                            icon="pi pi-check"
                            onClick={this.informarPagamento}
                            style={{ maxWidth: '15rem' }}
                        />
                    </>
                )
            }
            else{
                return (
                    <div />
                )
            }
        }

        const renderBotaoDesfazerPagamento = () => {
            if(this.props.element.tipoDetalhamento === ConstantsUtil.saidaLabel){
                return (
                    <>
                        <Button
                            label="Desfazer Pagamento"
                            className="p-button-danger small-font small-button right-button"
                            icon="pi pi-undo"
                            onClick={this.callDesfazerPagamento}
                            style={{ maxWidth: '15rem' }}
                        />
                    </>
                )
            }
            else{
                return (
                    <div />
                )
            }
        }

        return(
            <>
            <Dialog
                visible={this.props.visible}
                style={{ width: '95vw',}}
                header={this.getCompleteHeader()}
                modal
                className="p-fluid"
                footer={footer}
                onHide={this.hideDialog}
            >

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    
                    {renderBotaoUnificar()}

                    {renderBotaoInformarPagamento()}
                    {renderBotaoDesfazerPagamento()}

                    <Button
                        label={`Valor Total: ${this.state.valorTotal}`}
                        className="p-button-primary small-font small-button"
                        style={{ maxWidth: '20rem' }}
                    />                    
                    
                    {/* Botão à direita */}
                    <Button
                        label="Exportar"
                        className="p-button-success small-font small-button"
                        icon="pi pi-file-excel"
                        onClick={() => GeneralServices.exportExcel(this.detalhamentoToExportTemplate(), "Lançamentos", this.getCompleteHeader())}
                        style={{ maxWidth: '10rem' }}
                    />

                </div>

                {renderTable(this.getList(), true, false)}

                {renderDetalhamentoUnificacaoSaidaDialog()}

            </Dialog>

            <EditProvisaoDialog
                visible={this.state.displayEditProvisaoDialog}
                provisaoId={this.state.idProvsisaoToEdit}
                provisaoRecebimentoId={this.state.idProvisaoRecebimentoToEdit}
                search={this.searchAposSalvarProvisao}
                // startLoadingTable={() => this.setState({loading: true})}
                // finishLoadingTable={() => this.setState({loading: false})}
                hideDialog={this.hideEditProvisaoDialog}
            />

            {renderDadosPagamentoDialog()}

            {renderBoletoSugeridoOverlayPanel()}

            <Tooltip ref={this.statusConciliacaoTooltipRef} target=".status-conciliacao-bancaria-icon" position="top" mouseTrack mouseTrackTop={15} />

            {renderInformarPagamentoDialog()}

            {renderConfirmDesfazerPagamentoDialog()}

            </>
        )
    }

}

export default DetalhamentoFluxoCaixaPrevistoDialog